module.exports = __webpack_public_path__ + "img/pending_small.4fd1ad80.svg";